import React from 'react';
import * as Styled from './StyledPageImage';

export const PageImage = props => (
    <Styled.PageImage {...props}>
        {props.children}
        {!!props.src && <img src={props.src} alt={props.alt} />}
        {!!props.caption && <figcaption>{props.caption}</figcaption>}
    </Styled.PageImage>
);
export const Image = PageImage;
export default PageImage;
